"use strict";

var _Fragment;
import { useLayoutEffect } from 'react';
import { GTM_WEB } from '@autoguru/global-configs';
import { Helmet } from 'react-helmet';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment2 } from "react/jsx-runtime";
export const SpaAnalyticsHead = () => {
  useLayoutEffect(() => {
    ((w, d, s, l, i) => {
      w[l] = w[l] || [];
      w[l].push({
        'gtm.start': new Date().getTime(),
        event: 'gtm.js'
      });
      const f = d.getElementsByTagName(s)[0];
      const j = d.createElement(s);
      const dl = l !== 'dataLayer' ? `&l=${l}` : '';
      // @ts-ignore
      j.async = true;
      // @ts-ignore
      j.src = `https://www.googletagmanager.com/gtm.js?id=${i}${dl}`;
      f.parentNode.insertBefore(j, f);
    })(window, document, 'script', 'dataLayer', GTM_WEB);
  }, []);
  return _Fragment || (_Fragment = /*#__PURE__*/_jsx(_Fragment2, {
    children: /*#__PURE__*/_jsxs(Helmet, {
      children: [/*#__PURE__*/_jsx("link", {
        href: "https://www.google-analytics.com",
        rel: "preconnect",
        crossOrigin: "anonymous"
      }), /*#__PURE__*/_jsx("link", {
        href: "https://www.googletagmanager.com",
        rel: "preconnect",
        crossOrigin: "anonymous"
      }), /*#__PURE__*/_jsx("link", {
        href: "https://www.gstatic.com",
        rel: "preconnect",
        crossOrigin: "anonymous"
      }), /*#__PURE__*/_jsx("link", {
        href: "https://cdn.heapanalytics.com",
        rel: "preconnect",
        crossOrigin: "anonymous"
      })]
    })
  }));
};